import { Env, readFromEnv } from "@cinch-nx/environments";
import axios from "axios";
import useSWR from "swr";
import { keepPreviousDataWhileLoadingNewDataMiddleware } from "../../swr-middleware/keep-previous-data-while-loading-new-data-middleware";
import { convertSearchFiltersToQueryParams } from "../../utils";
import { useCinchStores } from "../use-cinch-stores/use-cinch-stores";
const httpClient = axios.create();
const fetcher = async (url)=>await httpClient.get(url).then((res)=>res.data);
export function useSearchResults(params) {
    const searchApiUrl = readFromEnv(Env.SearchServiceUrl);
    const { allCinchStoresLowercase  } = useCinchStores();
    const queryParams = convertSearchFiltersToQueryParams(params, allCinchStoresLowercase);
    const url = `${searchApiUrl}/vehicles${queryParams.toString() ? `?${queryParams}` : ""}`;
    return useSWR(url, fetcher, {
        use: [
            keepPreviousDataWhileLoadingNewDataMiddleware
        ]
    });
}
